import { Component, HostListener } from '@angular/core';

export const SUBSCRIPTION_STATES = [
  { title: '契約中', icon: 'package_2', className: 'text-success' },
  { title: '開始前', icon: 'schedule', className: 'text-warning' },
  { title: '終了', icon: 'event_busy', className: 'text-secondary' },
];

export function subscriptionState(status: string) {
  return SUBSCRIPTION_STATES.find(state => state.title === status) ?? SUBSCRIPTION_STATES[2];
}

@Component({
  selector: 'app-subscription-state-legend', standalone: true,
  template: `
    <button class="btn p-0 ml-1 text-info js-state-legend-trigger" type="button"
      title="状態アイコンの凡例" aria-label="状態アイコンの凡例" [attr.aria-expanded]="open"
      (click)="toggle($event)" style="line-height: 1;">
      <span class="material-symbols-outlined" aria-hidden="true" style="font-size: 18px; vertical-align: middle;">info</span>
    </button>
    @if (open) {
      <div class="position-fixed bg-white border rounded shadow-sm p-2 text-left js-state-legend"
        (click)="$event.stopPropagation()" [style.top.px]="top" [style.left.px]="left" style="min-width: 180px; z-index: 1080;">
        @for (state of states; track state.title) {
          <div class="d-flex align-items-center mb-1">
            <span class="material-symbols-outlined mr-2 {{ state.className }}" aria-hidden="true" style="font-size: 22px;">{{ state.icon }}</span>
            <span>{{ state.title }}</span>
          </div>
        }
      </div>
    }
  `,
})
export class SubscriptionStateLegendComponent {
  readonly states = SUBSCRIPTION_STATES;
  open = false;
  top = 0;
  left = 0;

  toggle(event: MouseEvent): void {
    event.stopPropagation();
    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    this.top = rect.bottom + 120 > window.innerHeight ? Math.max(8, rect.top - 120) : rect.bottom + 4;
    this.left = Math.max(8, Math.min(rect.left, window.innerWidth - 188));
    this.open = !this.open;
  }

  @HostListener('document:click')
  @HostListener('document:keydown.escape')
  @HostListener('window:scroll')
  @HostListener('window:resize')
  close(): void { this.open = false; }
}
